// material-ui
import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Modal,
    Checkbox,
    Grid,
    ToggleButtonGroup,
    ToggleButton,
    Button,
    Typography,
    TextField,
    Select,
    MenuItem
} from '@mui/material';
import { ManageAccounts, Cancel } from '@mui/icons-material';
import { styled, useTheme } from '@mui/material/styles';
import { useState, useEffect  } from 'react';
import { deepPurple, grey } from '@mui/material/colors';
import useFetchData from 'hooks/useFetchData';
import { axiosInstance } from 'utils/axios';
import { useSelector } from 'react-redux';
import { selectCurrentToken } from 'features/auth/authSlice';
import { successAlert, errorAlert, warningAlert } from 'ui-component/Toasts';

import { useTranslation } from "react-i18next";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 1000,
    width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '20px',
    borderRadius: '10px'
};

const ApproveDepositModal = ({
    approveDepositModalOpen,
    setApproveDepositModalOpen,
    row,
    fetchDeposit
}) => {
    const { t } = useTranslation();
    const token = useSelector(selectCurrentToken);
    const [extraCappingAmount, setExtraCappingAmount] = useState('');
    
    const [updateButtonDisabled, setUpdateButtonDisabled] = useState(false);
    const submitUpdateDeposit = async () => {
        setUpdateButtonDisabled(true);

        try {
            const res = await axiosInstance.put(
                '/Deposit',
                {
                    id: row.id,
                    statusID: 2,
                    cappingAmount: extraCappingAmount ? parseFloat(extraCappingAmount) : 0
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );
            if (res.status === 200) {
                successAlert('成功批准充值');
                fetchDeposit();
                setApproveDepositModalOpen(false);
            } else {
                errorAlert('发生错误');
            }
        } catch (error) {
            console.log(error);
        } finally {
            setUpdateButtonDisabled(false);
        }
    };

    return (
        <>
            <Modal
                open={approveDepositModalOpen}
                onClose={() => setApproveDepositModalOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Typography id="modal-modal-title" variant="h3" component="h2">
                            {t("deposit.approveDeposit")}
                        </Typography>
                        <Cancel onClick={() => setApproveDepositModalOpen(false)} sx={{ width: '30px', height: '30px' }} />
                    </Box>
                    <Typography
                        sx={{
                            fontSize: '25px',
                            whiteSpace: 'nowrap',
                            textAlign: 'center',
                            marginTop: '30px'
                        }}
                    >
                        {t("deposit.confirmApproveDeposit")} ?
                    </Typography>
                    {/* <Grid item container pr={{ md: '5px' }}>
                        <Grid key='maxWithdrawalAmount1' xs={5} sx={{ mt: 2 }} style={{alignContent: 'center'}}>
                            <TextField
                                name="remark"
                                type="number"
                                onWheel={(e) => e.target.blur()}
                                label={t("customer.extraCappingAmount")}
                                fullWidth
                                variant="outlined"
                                value={extraCappingAmount}
                                onChange={(e) => setExtraCappingAmount(e.target.value)}
                            />
                        </Grid>
                        <Grid key='maxWithdrawalAmount2' xs={7} sx={{ mt: 2 }}>
                            <Typography
                                sx={{
                                    fontSize: '15px',
                                    whiteSpace: 'nowrap',
                                    textAlign: 'center'
                                }}
                            >
                                {t("customer.totalCappingAmount")} <br/>
                                {row.amount} ( {t("deposit.depositAmount")} ) + {extraCappingAmount ? extraCappingAmount : 0} ( {t("customer.extraCappingAmount")} ) = {(row.amount ? parseFloat(row.amount) : 0) + (extraCappingAmount ? parseFloat(extraCappingAmount) : 0)}
                            </Typography>
                        </Grid>
                    </Grid> */}
                    <Box style={{alignItems: 'center', textAlign: 'center'}}>
                        <Button
                            variant="contained"
                            sx={{
                                mx: 'auto',
                                width: '150px',
                                backgroundColor: deepPurple[500],
                                marginTop: '30px'
                            }}
                            onClick={submitUpdateDeposit}
                            disabled={updateButtonDisabled}
                        >
                            {t("deposit.confirm")}
                        </Button>
                        <Button
                            variant="contained"
                            sx={{
                                mx: 'auto',
                                width: '150px',
                                backgroundColor: 'grey',
                                marginTop: '30px',
                                marginLeft: '30px'
                            }}
                            onClick={() => setApproveDepositModalOpen(false)}
                            disabled={updateButtonDisabled}
                        >
                            {t("deposit.cancel")}
                        </Button>
                    </Box>
                </Box>
            </Modal>
        </>
    );
};

export default ApproveDepositModal;